export const getOAuthURL = (provider, userType) => {
  const API_URL = process.env.REACT_APP_API_URL;
  
  if (userType === 'therapist') {
    return `${API_URL}/therapists/auth/${provider}`;
  } else {
    return `${API_URL}/users/auth/${provider}`;
  }
};

export const openOAuthPopup = (url, name = 'oauth') => {
  const width = 600;
  const height = 600;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  
  return window.open(
    url,
    name,
    `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
  );
};

export const handleOAuthCallback = () => {
  return new Promise((resolve, reject) => {
    const messageHandler = (event) => {
      if (event.origin !== window.location.origin) return;
      
      if (event.data.type === 'OAUTH_SUCCESS') {
        window.removeEventListener('message', messageHandler);
        resolve(event.data);
      } else if (event.data.type === 'OAUTH_ERROR') {
        window.removeEventListener('message', messageHandler);
        reject(new Error(event.data.error));
      }
    };
    
    window.addEventListener('message', messageHandler);
  });
};